var $$ = $$ || {};

$$.ProductCard = class ProductCard {
	constructor (root) {
		this.root = root;

		this._bindEvents();
	}

	_bindEvents () {
		this.root.on('click', '.js-remove', (event) => {
			if( $(event.currentTarget).data('id') ) {
				var data = {
					action: "delete",
					id: $(event.currentTarget).data('id')
				};

				$.ajax({
					url: $$.Config.deleteInCart,
					method: 'POST',
					data: data,
					success: (response) => {
						response = $.parseJSON(response);

						if (response.success) {
							$$.Noty['successMessage'](response.success);
							$(event.delegateTarget).remove();
						} else {
							$$.Noty['errorMessage'](response.error);
						}
					}
				});
			}
		});
	}
};
